function getBaseUrl() {
    // baseUrl should be "https://flavrapptest.flavia-it.de", "https://flavrapp.flavia-it.de",
    // or "https://localhost:9000" etc.,
    let baseUrl = `${location.protocol}//${window.location.host}`;
    // get the HTMLScriptElement for this script
    const script = document.currentScript;
    if (script === undefined || script === null) {
        return baseUrl;
    }
    const src = script.getAttribute("src");
    if ((src === null || src === void 0 ? void 0 : src.startsWith("http")) === true) {
        const i = src.lastIndexOf("/");
        baseUrl = src.substring(0, i);
    }
    return baseUrl;
}
export const BASE_URL = getBaseUrl();
